// sagas.js
import { call, put, takeLatest } from "redux-saga/effects";
import { getOnlineCourseSuccess, getOnlineCourseFailure } from "./actions";
import { GET_ONLINE_COURSE_REQUEST } from "../../actionTypes";
import AxiosInstance from "../../../services/AxiosInstance";
function* handleGetOnlineCourse(action) {
  try {
    const response = yield call(() =>
      AxiosInstance().get(
        "/jobseeker/get_courses",
        action.payload
      )
    );
    console.log(response);
    yield put(getOnlineCourseSuccess(response.data));
  } catch (error) {
    yield put(getOnlineCourseFailure(error));
  }
}

function* getOnlineCourseSaga() {
  yield takeLatest(GET_ONLINE_COURSE_REQUEST, handleGetOnlineCourse);
}

export default getOnlineCourseSaga;
